module.exports = __webpack_public_path__ + "static/media/workers_yellow_transparent.2b8e43d7.png";